var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialog.title,
        visible: _vm.dialog.visible,
        width: "680px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.dialog, "visible", $event)
        },
      },
    },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.table.bodys,
            "highlight-current-row": "",
            stripe: "",
            border: "",
            "row-key": _vm.table.id,
            "max-height": "600px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "资源位 code",
              prop: "resourceItemCode",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作时间",
              prop: "time",
              width: "180px",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "操作人", prop: "operator", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作类型", prop: "op", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("optionsPipe")(row.op, _vm.options.type)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }